<template>
	<div>
		<dv-border-box-12 class="padding-lr-sm margin-top-xs dayTimeBox">
			<SecondTitle :secTitle="secTitle" class="margin-bottom-sm"></SecondTitle>
			<Chart :cdata="cdata" :width="style.width" :height="style.height"/>
		</dv-border-box-12>
	</div>
</template>

<script>
import Chart from '../echart/chart.vue';
import SecondTitle from '../secondTitle.vue';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
		secTitle:{
		  title:'预警事件趋势'
		},
		  cdata: {
			category: [
			  "1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月",
			],
			rateData: [],
			id:"userAddChart",
			legendData:[],
			series:[
				{
				  name: "",
				  type: "line",
				  smooth: true,
				  // showAllSymbol: true,
				  // symbol: "emptyCircle",
				  symbolSize: 1,
				  // yAxisIndex: 1,
				  itemStyle: {
					color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
						{ offset: 0, color: "#3DDDFF" },
						{ offset: 1, color: "#62FBFF" }
					])
				  },
				  data: []
				},
			]
		  },
		  style:{
			width: '430',
			height: '200'
		  }
    };
  },
  components: {
    Chart,
    SecondTitle,
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectAlarmCurrent(data);
    },
    selectAlarmCurrent(data={}){
      let _this = this;
      let params = {};
      if(data){
				params = {
					"enCode":"TiDB-shengshiqu-yujingshijianqushi",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-yujingshijianqushi"//TiDB-全国-预警事件趋势
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
  		  console.log("预警事件趋势",res)
          let alarmNum=[];
          let xList=[];
          res.map(item=>{
            alarmNum.push(item.alarmNum);
            xList.push(item.cur_date);
          })
          this.cdata.category = xList;//
          this.cdata.series[0].data = alarmNum;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
	.dayTimeBox{
		width: 463px;
	}
</style>